export const ATTENDANCE_LOG_TOUR_ID = 'attendance-log'

export const ATTENDANCE_LOG_ONBOARDING_STEPS = [
  {
    title: 'Este é o espelho de ponto',
    body: 'Aqui fica o mês inteiro de uma pessoa: as quatro batidas, o total, o banco de horas e se o dia foi assinado.',
  },
  {
    target: '[data-onboarding="log-employee"]',
    title: 'De quem é o espelho',
    body: 'O nome abre a lista. Busque o colaborador e troque sem voltar para a tela anterior.',
  },
  {
    target: '[data-onboarding="log-month"]',
    title: 'O mês na mão',
    body: 'As setas andam o período. O banco de horas e os totais seguem o mês que está na tela.',
  },
  {
    target: '[data-onboarding="log-export"]',
    title: 'Levar o espelho',
    body: 'O botão verde baixa o PDF deste mês. O da impressora abre o mesmo espelho e manda para a impressora.',
  },
  {
    target: '[data-onboarding="log-table"]',
    title: 'O dia em colunas',
    body: 'Cada linha é um dia. Total, banco, atestado e status ficam no fim. Fim de semana aparece diferente.',
  },
  {
    target: '[data-onboarding="log-times"]',
    title: 'Ajustar o horário',
    body: 'Quem tem a permissão Editar horários clica na hora e corrige. Quem não tem, só consulta. Sábado e domingo não editam.',
  },
  {
    target: '[data-onboarding="log-signature"]',
    title: 'Assinatura do dia',
    body: 'O dedo é batida assinada. O relógio ainda está pendente. Confira antes de fechar o mês.',
  },
]
